import React from 'react';
import './PreparationSteps.css';

const PreparationSteps = ({preparation}) => {

    return (
        <section className="section">
            <h3>Pasos de preparación</h3>
            <div className="steps-list">
                {preparation.map((pre, index) =>
                    <div className="step" key={index}>
                        <span className="step-number">{pre.step}.</span>
                        <p>{pre.description}</p>
                    </div>
                )}
            </div>
        </section>
    );
};

export default PreparationSteps;